export function shortId(id) {
  if (id == null || id === '') return '—';
  const s = String(id);
  return s.length > 10 ? `${s.slice(0, 8)}…` : s;
}

export function personDisplayName(person) {
  if (!person) return '';
  return (
    person.name ||
    person.nome ||
    [person.first_name, person.last_name].filter(Boolean).join(' ') ||
    person.email ||
    ''
  );
}

export function complaintDisplayName(row) {
  if (!row) return '';
  return row.local || row.cidade || row.protocolo || row.numero || '';
}

export function processoDisplayName(row) {
  if (!row) return '';
  return row.numero || row.processo_numero || '';
}

export function labelFromMap(map, id, fallbackFn) {
  if (id == null || id === '') return '—';
  const hit = map?.[id] || map?.[String(id)];
  if (hit) return hit;
  return fallbackFn ? fallbackFn(id) : shortId(id);
}

export function indexById(rows, labelFn) {
  const map = {};
  for (const row of rows || []) {
    if (!row?.id) continue;
    map[row.id] = labelFn(row) || shortId(row.id);
  }
  return map;
}
